import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable translations has been removed and is no longer part of the public API. 
import { translationChunksConfig, translationsEn } from '@spartacus/assets';
import {
  I18nConfig,
  OccConfig,
  PageMetaResolver,
  provideConfig,
  SiteContextConfig,
  AuthConfig,
} from '@spartacus/core';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { defaultB2BCheckoutConfig } from '@spartacus/checkout/b2b/root';
import {
  PWAModuleConfig,
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { MyContentPageMetaResolver } from '../shared/services/mycontentpage-meta-resolver';
import { AsmConfig } from '@spartacus/asm/root';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: environment.baseUrl,
          // CSRF is required for custom login page
        },
      },
      pwa: {
        enabled: true,
        addToHomeScreen: true,
      }
    }),
  // provideConfig(<AuthConfig>{
  //     authentication: {
  //       client_id: 'mobile_android_public',
  //       client_secret: 'secret', // Required for password grant type
  //       baseUrl: environment.baseUrl + 'authorizationserver',
  //       tokenEndpoint: '/oauth/token',
  //       revokeEndpoint: '/oauth/revoke',
  //       logoutUrl: '/logout',
  //       userinfoEndpoint: '/oauth/userinfo',
        
  //       // For custom login page with OAuth: use Resource Owner Password Credentials
  //       loginUrl: '/oauth/token', // Use token endpoint for ROPC flow
        
  //       // Important: This tells Spartacus to NOT redirect to authorization server
  //       OAuthLibConfig: {
  //         responseType: 'password', // Use password grant type for custom login
  //         scope: '',
  //         showDebugInformation: true,
  //         customTokenParameters: ['token_type'],
  //         strictDiscoveryDocumentValidation: false,
  //         skipIssuerCheck: true,
  //         disablePKCE: true, // PKCE not used with password grant
  //         oidc: false,
  //         clearHashAfterLogin: false,
  //         requireHttps: false, // Set to true in production
  //       }
  //     },
      
  //   }),
    provideConfig(<SiteContextConfig>{
      context: {
        currency: environment.currency,
        language: environment.language,
        baseSite: environment.baseSite,
        // urlParameters: ['baseSite', 'language', 'currency']
      },
      // tslint:disable-next-line:no-angle-bracket-type-assertion
    }),
    {
      provide: PageMetaResolver,
      useExisting: MyContentPageMetaResolver,
      multi: true,
    },
    provideConfig(<AsmConfig>{
// TODO:Spartacus - The type of property 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; userIdHttpHeader?: { enable?: boolean; }; }' changed to: 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; asmSessionSupport?: { enabled?: boolean; }; userIdHttpHeader?: { enable?: boolean; }; createCustomer?: { enable?: boolean; }; }' 
      asm: {
        userIdHttpHeader: {
          enable: true,
        },
        agentSessionTimer: {
          startingDelayInSeconds: 720,
        },
        customerSearch: {
          maxResults: 20,
        },
        
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        backend: {
          loadPath: '/i18n-assets/{{lng}}/{{ns}}.json?nocache=' + Math.random(),
          // crossOrigin: true (use this option when i18n assets come from a different domain)
        },

        chunks: translationChunksConfig,
        resources: {en:translationsEn},
        fallbackLang: 'en',
      },
      // tslint:disable-next-line:no-angle-bracket-type-assertion
    }),
    provideConfig(defaultB2bOccConfig),
    provideConfig(defaultB2BCheckoutConfig),
    provideConfig(<PWAModuleConfig>{
      pwa: {
        enabled: true,
        addToHomeScreen: true,
      },
    })
  ],
})
export class SpartacusConfigurationModule {}
